// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body.web-player-body-v2 {\n  margin: 0;\n  padding: 0;\n  height: 100vh;\n  width: 100%;\n  overflow: hidden;\n}\nbody.web-player-body-v2 #mainAppWrapper {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
